import coach1Image from '../assets/images/coach.jpg'; // Replace with the actual image path
import coach2Image from '../assets/images/coach.jpg'; // Replace with the actual image path
import coach3Image from '../assets/images/coach.jpg'; // Replace with the actual image path
import coach4Image from '../assets/images/coach.jpg'; // Replace with the actual image path

const coachesData = [
    {
        id: 1,
        fullName: "John Doe",
        age: 45,
        contact: "john.doe@example.com",
        address: "123 Main St, Springfield, USA",
        description: "John is an experienced coach with over 20 years in the industry...",
        imageUrl: coach1Image,
    },
    {
        id: 2,
        fullName: "Jane Smith",
        age: 38,
        contact: "jane.smith@example.com",
        address: "456 Elm St, Springfield, USA",
        description: "Jane has a proven track record of developing young talent...",
        imageUrl: coach2Image,
    },
    {
        id: 3,
        fullName: "David Johnson",
        age: 50,
        contact: "david.johnson@example.com",
        address: "789 Maple St, Springfield, USA",
        description: "David specializes in strength and conditioning...",
        imageUrl: coach3Image,
    },
    {
        id: 4,
        fullName: "Emily Davis",
        age: 42,
        contact: "emily.davis@example.com",
        address: "101 Oak St, Springfield, USA",
        description: "Emily is known for her strategic approach to game preparation...",
        imageUrl: coach4Image,
    },
];
export default coachesData;